import { ElementType, PropsWithChildren, useId } from "react";

import { motion } from "motion/react";

import { PolymorphicProps } from "shared/types";
import { cn } from "shared/utils/cn";

import { TabsContext } from "./context";
import { tabsVariants, TabsVariantsProps } from "./styles";

export const Tabs = <E extends ElementType = "ul">(
  props: PropsWithChildren<
    PolymorphicProps<E, { className?: string } & TabsVariantsProps>
  >
) => {
  const {
    as: Comp = motion.ul,
    variant,
    children,
    className,
    ...restProps
  } = props;
  const lineLayoutId = useId();

  return (
    <Comp
      layout
      layoutRoot
      {...restProps}
      className={cn(tabsVariants({ className, variant }), className)}
    >
      <TabsContext.Provider value={{ variant, lineLayoutId: lineLayoutId }}>
        {children}
      </TabsContext.Provider>
    </Comp>
  );
};
